import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MUIICon from '@mui/material/Icon';
import { useAriaAndDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { MATERIAL_SYMBOLS_FULL_FONT_FAMILY, useTheme } from '@famly/mf_theme';
import { useTooltipRequiredProps } from '@famly/mf_data-display_tooltip';
import { CustomIcon } from './custom-icon';
import { isCustomIconName } from './custom-icon-registry';
import { isInMaterialSymbolsSubset } from './material-symbols-subset/is-in-material-symbols-subset';
export const Icon = ({ name, color: colorFromProps, filled, size, ref, ...props }) => {
    const theme = useTheme();
    const dataAriaProps = useAriaAndDataProps(props);
    const tooltipRequiredProps = useTooltipRequiredProps(props);
    const resolvedColor = colorFromProps ? theme.colorPalette[colorFromProps] : undefined;
    const color = resolvedColor !== null && resolvedColor !== void 0 ? resolvedColor : 'inherit';
    const sx = {
        fontVariationSettings: filled
            ? `
        'FILL' 1,
        'wght' 300,
        'GRAD' 0,
        'opsz' 24
    `
            : undefined,
        fontSize: size ? `${size}px` : undefined,
        color,
        // Adding these styles to make the icon work better with tooltips
        display: 'inline-flex',
        cursor: 'inherit',
        lineHeight: 1,
    };
    if (isCustomIconName(name)) {
        return (_jsx(CustomIcon, { name: name, size: size, 
            // SVGs can't resolve `inherit`, so fall back to `currentColor` to inherit the text color.
            color: resolvedColor !== null && resolvedColor !== void 0 ? resolvedColor : 'currentColor', filled: filled, sx: sx }));
    }
    // The theme renders icons in the subset font, which has no glyph for a name the code never writes
    // out, such as one from the backend. `MATERIAL_SYMBOLS_FONT_STACK` says why it cannot fall back.
    const fontFamily = isInMaterialSymbolsSubset(name) ? undefined : MATERIAL_SYMBOLS_FULL_FONT_FAMILY;
    return (_jsx(MUIICon, { ref: ref, sx: { ...sx, fontFamily }, ...dataAriaProps, ...tooltipRequiredProps, children: name }));
};
Icon.displayName = 'Icon';
